module.exports = __webpack_public_path__ + "img/laboratory_03.a3f0f3aa.png";